"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getHeaders(authToken, correlationId) {
    return {
        'authorization': bearerToken(authToken),
        'x-request-id': correlationId,
    };
}
exports.getHeaders = getHeaders;
function bearerToken(authToken) {
    return authToken.startsWith('Bearer ') ? authToken : `Bearer ${authToken}`;
}
exports.bearerToken = bearerToken;
let BASE_URL = 'https://configuration.logistics.cimpress.io';
function getBaseUrl() {
    return BASE_URL;
}
exports.getBaseUrl = getBaseUrl;
function setBaseUrl(baseUrl) {
    BASE_URL = baseUrl;
}
exports.setBaseUrl = setBaseUrl;
//# sourceMappingURL=shared.js.map